module.exports = __webpack_public_path__ + "img/aomen6.52c7eab0.jpg";